import React, { useState } from "react";
import { BsPlusLg } from "react-icons/bs";
import InputTag from "./InputTag";

const TextInput = ({ item }) => {
  const {
    label,
    name,
    type,
    defaultValue,
    multiple,
    multipleData,
    required,
    disabled,
    fullCol,
    info,
    pattern,
  } = item;

  const [quantityCount, setCount] = useState(multipleData);
  const handleAddElement = () => {
    setCount((current) => [
      ...current,
      {
        label: label,
        type: type,
        name: "",
        defaultValue: [],
      },
    ]);
  };
  return (
    <div
      className={`${
        fullCol ? "col-span-3" : "col-span-1"
      } flex flex-row gap-4 items-centers w-full`}
    >
      <div className="col-span-2 w-full">
        {multipleData ? (
          quantityCount.map((item, index) => (
            <InputTag
              key={index}
              label={label}
              length={index + 1}
              name={name}
              defaultValue={item.defaultValue}
              type={type}
              multiple={multiple}
              required={required}
              disabled={disabled}
              info={info}
              pattern={pattern}
            />
          ))
        ) : (
          <InputTag
            label={label}
            length={0}
            name={name}
            defaultValue={defaultValue}
            type={type}
            multiple={multiple}
            required={required}
            disabled={disabled}
            info={info}
            pattern={pattern}
          />
        )}
      </div>

      {multiple && (
        <div className="flex justify-center items-end">
          <button
            onClick={handleAddElement}
            type="button"
            className="btn btn-circle border hover:bg-gray-50 border-gray-400 rounded-full p-4"
          >
            <BsPlusLg />
          </button>
        </div>
      )}
    </div>
  );
};

export default TextInput;
